import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { fill: true },
  },
});

type ChatActiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function ChatActiveIcon({
  className,
  pathClassName = "fill-black",
  ...props
}: ChatActiveIconProps) {
  return (
    <Svg
      width={29}
      height={29}
      viewBox="0 0 29 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M26.154 14.501a11.527 11.527 0 01-.887 4.468 11.342 11.342 0 01-2.531 3.78 11.667 11.667 0 01-3.78 2.532c-1.416.59-2.935.891-4.468.887a11.339 11.339 0 01-4.527-.922l-4.259.63a2.262 2.262 0 01-2.578-2.718l.583-4.259a11.153 11.153 0 01-.863-4.398c-.004-1.53.297-3.045.887-4.457a11.667 11.667 0 012.52-3.791 11.877 11.877 0 013.792-2.532 11.667 11.667 0 0112.716 2.532 11.27 11.27 0 012.532 3.791 11.47 11.47 0 01.863 4.457z"
        className={pathClassName}
      />
    </Svg>
  );
}

export default ChatActiveIcon;
